import gql from 'graphql-tag';
import { PageInfoFragment } from '@app/pages/cmms/graphql/cmms-fragments';
import { FileFragment } from '@app/pages/cmms/graphql/file.queries';

//TODO Currently type for classifications is only BCT, but later there will be more types
// and maybe multiselect filter will not be enough, so handle it later
// also the types and other config is now declared in file au-file-classifications.ts
export const ClassificationsFilterQuery = gql`
	query ClassificationsFilterQuery(
		$search: String
		$first: Int
		$type: ClassificationTypes
	) {
		classificationsV2(name: $search, first: $first, type: $type) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				node {
					typeId
					name
				}
			}
			totalCount
		}
	}
	${PageInfoFragment}
`;

export const LocationAssetFilterQuery = gql`
	query LocationAssetFilterQuery(
		$search: String
		$first: Int
		$tableType: TableTypeEnum = assets
	) {
		locationMappings(search: $search, first: $first, tableType: $tableType) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				node {
					name
					locationId
				}
			}
			totalCount
		}
	}
	${PageInfoFragment}
`;
export const LocationFilterQuery = gql`
	query LocationMappingFilterQuery($search: String, $first: Int) {
		locationMappings(search: $search, first: $first) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				node {
					name
					locationId
				}
			}
			totalCount
		}
	}
	${PageInfoFragment}
`;

export const fileDataTypeFilterQuery = gql`
	query fileFilterDataTypeQuery($search: [String], $first: Int) {
		files(type: $search, first: $first) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...FileFragment
				}
			}
			totalCount
		}
	}
	${FileFragment}
	${PageInfoFragment}
`;
